import {queryOptions} from '@tanstack/react-query';

import {getMeta} from '@/api/bffSupport';

export const meta = () => {
  return queryOptions({
    queryKey: ['bff-support', 'meta'],
    queryFn: async ({signal}) => {
      const response = await getMeta({signal});
      if (response.status !== 200) {
        throw new Error('Failed to fetch smartseer profile');
      }
      return {
        // non US-ASCII characters are encoded e.g. "Böhlen" is received as B%C3%B6hlen
        userCity: decodeURIComponent(response.data.userCity),
      };
    },
  });
};
